import { useEffect, useState } from "react";
import { Container, Box, Text, Flex, useColorModeValue, List, IconButton } from "@chakra-ui/react";
import { FaCopy, FaCheck  } from "react-icons/fa";
import axios from "axios";
import { ReactSession } from "react-client-session";

const Referrals = (props) => {
    const [couponCode, setCouponCode] = useState("");
    const [totalRef, setTotalRef] = useState(0);
    const [discountPercentage, setDiscountPercentage] = useState(0);
    const [discountedAmount , setDiscountedAmount] = useState(0);
    const [copied,setCopied] = useState(false);

    useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/get_referral_details`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            if(res.data.result.referral_code){
              setCouponCode(res.data.result.referral_code);
            }
            
            if(res.data?.result?.total_referrals){
              setTotalRef(res.data.result.total_referrals);
              const discount = res.data.result.total_referrals * 10;
              setDiscountPercentage(res.data.result.total_referrals < 10 ? res.data.result.total_referrals * 10 : 100);
              if(discount !== 0 && props.refBillingAmount !== 0) {
                if(discount > 99) {
                  setDiscountedAmount(0);
                } else {
                  setDiscountedAmount(props.refBillingAmount - ((discount / 100) * props.refBillingAmount));
                }
              }
            }
            props.setLoading(false);
          } else {
            setCouponCode("");
            props.setLoading(false);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setCouponCode("");
          props.setLoading(false);
        });
    } else {
      // navigate("/get-api-key");
    }
  }, []);

  const copyToclipboard = (text) => {
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
  }

  // useEffect(() => {
  //   setTimeout(() => {
  //     props.setLoading(false);
  //   }, 800);
  // }, []);
  return (
    <>
      <Container maxW={"8xl"}>
        <Box as="div" pb={{ base: "16px", md: "16px" }}>
          <Box as="div">
            <Text
              as="span"
              fontFamily={"heading"}
              color={useColorModeValue("brand.white", "brand.white")}
              fontSize={"2xl"}
              lineHeight={"3xl"}
              fontWeight={"600"}
            >
              Referrals
            </Text>
            <Text color={"brand.white"}>
              Empower Your Network, Earn Rewards.
            </Text>
          </Box>
          <Box>
            <Text fontFamily={"body"} color={"brand.grey"} pt={2} pb={6} >
                Welcome to the Shyft Referral Program! We believe that great tools are best shared. By inviting your friends, colleagues, and network 
                to experience Shyft, you not only help them streamline their workflow but also unlock significant savings on your own subscription. 
                It's our way of saying thank you for being a valued member of the Shyft community. Start sharing your unique code today and watch your 
                rewards grow!
            </Text>
          </Box>
          <Box as="div">
            <Box border={"2px solid"} borderColor={"brand.red"} bg={"#000"}  paddingX={8} paddingY={4} borderRadius={12}>
                <Box as="div" borderBottom={"1px solid"} borderColor={"brand.red"} borderStyle={"dotted"} color={"brand.white"} fontFamily={"heading"} paddingBottom={"4"}>
                    Referral Rules
                </Box>
                <Flex justifyContent={"space-between"} paddingX={{"sm":2, "lg":"8"}} flexWrap={"wrap"}>
                    <RulePoints pointNumber={"1"} pointText={"If you sign up for a paid plan, you will get a referral code from Shyft."}></RulePoints>
                    <RulePoints pointNumber={"2"} pointText={"Share this referral code with other users, and they earn a 10% discount."}></RulePoints>
                </Flex>
                <Flex justifyContent={"space-between"} paddingX={{"sm":2, "lg":"8"}} flexWrap={"wrap"}>
                    <RulePoints pointNumber={"3"} pointText={"As soon as they use the referral code, you also earn a 10% discount for a month."}></RulePoints>
                    <RulePoints pointNumber={"4"} pointText={"These discounts add up to a 100%, based on how many users you refer."}></RulePoints>
                </Flex>
            </Box>
          </Box>
          {couponCode !== "" && <Box paddingY={"12"}>
            <Flex justifyContent={"space-between"} flexWrap={"wrap"}>
                <Box w={{base: "800px", "2xl":"400px"}} pb={{base: 8, "2xl":2}}>
                    <Text fontFamily={"heading"} color={"brand.white"} fontSize={"lg"} fontWeight={"600"}>Your Referral Code</Text>
                    <Box fontFamily={"body"} color={"brand.white"} bg={"#000"} paddingX={"20px"} paddingY={4} borderRadius={8} >
                        <Flex justifyContent={"space-between"}>
                            <Box as="div" pe={4} fontSize={"xl"} letterSpacing={"widest"}>{couponCode}</Box>
                            <Box>
                                
                                <IconButton size={"sm"} bg={"transparent"} color={"brand.yellow"} _hover={{ bg: "transparent" }} onClick={() => copyToclipboard(couponCode)}>{copied?<FaCheck size={"20"} color="#168300" />:<FaCopy size={"20"} color="#FBB901" />}</IconButton>
                            </Box>
                        </Flex>
                    </Box>
                </Box>
                
                <Box fontFamily={"body"} color={"brand.white"} w={{base: "800px", "2xl":"400px"}} pb={{base: 8, "2xl":2}}>
                    <Text fontFamily={"heading"} fontSize={"lg"} fontWeight={"600"}>Referrals this month</Text>
                    <Box bg={"#000"} paddingX={"20px"} paddingY={4} borderRadius={8}>
                        <Box fontSize={"xl"}>{totalRef}</Box>
                    </Box>
                </Box>
                
                <Box fontFamily={"body"} color={"brand.white"} w={{base: "800px", "2xl":"400px"}} pb={{base: 8, "2xl":2}}>
                    <Text fontFamily={"heading"} fontSize={"lg"} fontWeight={"600"}>Billing Amount</Text>
                    <Box bg={"#000"} paddingX={"20px"} paddingY={4} borderRadius={8}>
                        <Flex justifyContent={"space-between"} >
                            <Box fontSize={"xl"}>{discountedAmount > 0 ? discountedAmount :( (props.refBillingAmount > 0) ? `$ ${props.refBillingAmount.toString()}` : "--")}</Box>
                            <Box fontSize={"xl"} color={"green.400"}>{`-${discountPercentage}%`}</Box>
                        </Flex>
                    </Box>
                </Box>
                
            </Flex>
          </Box>}
          {couponCode === "" && <Box paddingY={8}>
            <Box border="2px dashed" borderColor={"brand.red"} paddingX={8} paddingY={4} borderRadius={12}>
                <Flex height={"200px"} justifyContent={"center"} alignItems={"center"}>
                  <Box textAlign={"center"}>
                    <Text fontFamily={"heading"} color={"brand.white"} fontSize={"lg"} fontWeight={"600"}>
                      A paid subscription is required to unlock your unique referral code.
                    </Text>
                    <Text fontFamily={"body"} color={"brand.grey"} pt={4}>
                      Upgrade to a paid plan today to start sharing your referral code and earning discounts!
                    </Text>
                  </Box>

                </Flex>
            </Box>
          </Box>}
          <Box>
            <Text
              as="span"
              fontFamily={"heading"}
              color={useColorModeValue("brand.white", "brand.white")}
              fontSize={"xl"}
              lineHeight={"3xl"}
              fontWeight={"600"}
            >
              Terms & Conditions
            </Text>
            <List fontFamily={"body"} color={"brand.grey"} pt={8}>
                <Text>
                    1. <Text as="b" color={"brand.white"}>Eligibility:</Text> The Shyft Referral Program is open to all users with an active, paid Shyft subscription. 
                    You must maintain a paid subscription to receive and apply referral discounts.
                </Text>
                <Text>
                    2. <Text as="b" color={"brand.white"}>Referral Code Use:</Text> The referred user must apply the unique referral code at the time of their initial sign-up 
                    for a paid plan to be eligible for the 10% discount. This discount applies to their first billing cycle.
                </Text>
                <Text>
                    3. <Text as="b" color={"brand.white"}>Discount Accumulation:</Text> The referrer earns a 10% discount on their monthly bill for each successful referral. 
                    A "successful referral" is defined as a new user who signs up for a paid plan using the referrer's code.
                </Text>
                <Text>
                    4. <Text as="b" color={"brand.white"}>Maximum Discount:</Text> The accumulated discounts are capped at a maximum of 100% of the referrer's monthly billing amount. 
                    If the total discount exceeds 100%, the remainder is not rolled over, but the referrer receives a full 100% discount 
                    (a free month) for that billing cycle.
                </Text>
                <Text>
                    5. <Text as="b" color={"brand.white"}>General:</Text> Shyft reserves the right to modify or terminate this program at any time. Referrals are subject to 
                    verification. Misuse of the program may result in the forfeiture of discounts and removal from the program.
                </Text>
            </List>
          </Box>
        </Box>
      </Container>
    </>
  );
};

const RulePoints = ({pointNumber, pointText}) => {
    return ( 
        <Box maxW={"500px"} py={4}>
            <Flex>
                <Box pt={"14px"}>
                    <Box borderRadius={"full"} bg={"brand.red"} fontFamily={"heading"} color={"brand.white"} padding="2" w={"40px"} h={"40px"} textAlign={"center"} fontWeight={"bold"}>
                        {pointNumber}
                    </Box>
                </Box>
                <Box>
                    <Box fontFamily={"heading"} color={"brand.white"} padding="2" ps={4}>
                        {pointText}
                    </Box>
                </Box>
            </Flex>
        </Box> 
    );
}
 

export default Referrals;
